



































import { Component, Prop, Mixins } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import CountriesStore from "@/mixins/constants/countriesStore";
import BrandMixin from "@/mixins/brandMixin";
import { IPhone } from "@/models/phones";
import parsePhoneNumber, {
  CountryCode,
  PhoneNumber
} from "libphonenumber-js/max";
import HasValidation from "@/mixins/HasValidation";

type PhoneInputType = Partial<Pick<IPhone, "phone" | "phone_code">> & {
  phone_country_code: string;
};

@Component
export default class PhoneNumberField extends Mixins(
  HasValidation,
  RequestPromises,
  CountriesStore,
  BrandMixin
) {
  // Props
  @Prop({ default: null })
  public value!: PhoneInputType | string | null;

  @Prop({ default: false })
  public autofocus!: boolean;

  @Prop({ default: false })
  public isObjectModel!: boolean;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: null })
  public countryCode!: string;

  @Prop({ default: false })
  public isRequired!: string;

  @Prop({ default: true })
  public isValidated!: boolean;

  // Data

  public phoneNumber = this.computedValue;
  public phoneInfo?: PhoneNumber | null = null;
  public debounceInput = this.$_.debounce(this.onInput, 250);

  // Computed

  public get computedValue(): string {
    if (this.isObjectModel) {
      const val = this.value as PhoneInputType;
      return `${val?.phone_code || ""}${val.phone || ""}`;
    } else {
      return this.value as string;
    }
  }

  public get brandCountry() {
    return this.countries?.find(
      country => country.id === this.brand?.country_id
    );
  }

  public get defaultCountryCode() {
    return this.countryCode || this.brandCountry?.code;
  }

  public get defaultCountry() {
    return this.countries.find(i => i.code === this.defaultCountryCode);
  }

  public get i18n() {
    return {
      phoneLabel: this.$t("_.phone") + `${this.isRequired ? "*" : ""}`,
      phoneLabelAs: this.$t("_.phone").toString()
    };
  }

  // Life-cycle methods

  public async created() {
    this.parseNumber(this.computedValue);
  }

  public mounted() {
    this.$watch("computedValue", () => (this.phoneNumber = this.computedValue));
  }

  // Methods

  public parseNumber(phone: string) {
    this.phoneNumber = phone ?? "";
    const phoneInfo = parsePhoneNumber(
      this.phoneNumber,
      this.defaultCountryCode as CountryCode
    );

    if (phoneInfo?.country) {
      this.phoneInfo = phoneInfo;
    } else {
      this.phoneInfo = null;
    }
  }

  public emitObjectInput() {
    if (this.phoneInfo?.isValid()) {
      this.$emit("input", {
        phone_code:
          (!this.$_.startsWith("+") ? "+" : "") +
          this.phoneInfo?.countryCallingCode,
        phone: this.phoneInfo?.nationalNumber,
        phone_country_code: this.phoneInfo?.country
      });
    } else {
      this.$emit("input", {
        phone_code: null,
        phone: this.phoneNumber,
        phone_country_code: null
      });
    }
  }

  public emitStringInput() {
    if (this.phoneInfo?.isValid()) {
      const phoneNumber = `${!this.$_.startsWith("+") ? "+" : ""}${
        this.phoneInfo?.countryCallingCode
      }${this.phoneInfo?.nationalNumber}`;
      this.$emit("input", phoneNumber);
    } else {
      this.$emit("input", this.phoneNumber);
    }
  }

  // Methods
  public onInput(e: any) {
    this.phoneNumber = e.target.value;
    this.parseNumber(e.target.value);
    this.isObjectModel ? this.emitObjectInput() : this.emitStringInput();
  }
}
